import { type NewsSearchResultsArgs } from 'hb-react/frontoffice/apps/NewsIndex/blocks/newsSearchResults/types';
import { NewsPinnedLoader } from 'hb-react/frontoffice/apps/NewsIndex/components/NewsPinnedLoader';
import {
  makeFetchItems,
  makeItemRenderer,
} from 'hb-react/frontoffice/apps/NewsIndex/utils';
import { ITEMS_QUERY_KEYS } from 'hb-react/frontoffice/components/BlocksRenderer/blocks/Items/utils/queryUtils';
import { BLOCKS } from 'hb-react/frontoffice/components/BlocksRenderer/shared';
import embeddedDetailsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/EmbeddedDetailsTemplate';
import oneColumnTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/OneColumnTemplate';
import twoColumnsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/TwoColumnsTemplate';

const SLIDER_CARD_HEIGHT = {
  s: 47,
  m: 95,
  l: 114,
  xl: 122,
};

export const newsPinnedItems = ({ config }: NewsSearchResultsArgs) => {
  const fetchItems = makeFetchItems(config.routes.news_url, {
    pinned_on_index_page: true, // flagEvNewsRevamp === false
    pinned_to_index_page: true, // flagEvNewsRevamp === true
  });

  const itemRenderer = makeItemRenderer({
    pinned: true,
  });

  return {
    ...BLOCKS.slider,
    attributes: {
      fetchItems,
      itemLoader: NewsPinnedLoader,
      itemRenderer,
      queryId: ITEMS_QUERY_KEYS.news.pinnedItems,
      title: ({
        isLoading,
        itemsSize,
      }: {
        isLoading: boolean;
        itemsSize: number;
      }) => (
        <>
          {s__('News|Highlighted news')} {!isLoading && `(${itemsSize})`}
        </>
      ),
      pictureHeight: SLIDER_CARD_HEIGHT,
      pictureSpace: 14,
    },
    templateAttributes: {
      [oneColumnTemplate.id]: {
        perPageBreakpoints: { s: 2, m: 3, l: 3, xl: 4 },
      },
      [twoColumnsTemplate.id]: {
        perPageBreakpoints: { s: 2, m: 3, l: 2, xl: 3 },
      },
      [embeddedDetailsTemplate.id]: {
        perPageBreakpoints: { s: 1, m: 2, l: 3, xl: 3 },
      },
    },
  };
};
